import { Card, Divider } from "antd";
import { ClipboardCheck, Target, TrendingUp } from "lucide-react";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import PerformanceHeader from "./PerformanceHeader";


const ProductivityMetrics = ( props ) => {
  const {} = props;

  	return (
      <PerformanceHeader
          title="Productivity Metrics"
          description="Current month performance"
					icon={<Target size={20}/>}
          cardTheme="white-purple"
      >
        <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="p-3 rounded-xl bg-white border border-blue-100">
              <p className="text-[10px] mb-1">Tasks Completed</p>
              <p className="text-[20px] font-bold card-text">48</p>
            </div>
            <div className="p-3 rounded-xl bg-white border border-blue-100">
              <p className="text-[10px] mb-1">On-Time Rate</p>
              <p className="text-[20px] font-bold card-text">93.75%</p>
            </div>
        </div>
          <div className="flex items-center justify-between text-[11px]">
            <span>Tasks On Time:</span>
            <span className="font-semibold text-green-600">45 / 48</span>
          </div>          
          <div className="flex items-center justify-between text-[11px]">
            <span>Avg. Completion:</span>
            <span className="font-semibold">3.2 days</span>
          </div>
          <div className="flex items-center justify-between text-[11px]">
            <span>Active Projects:</span>
            <span className="font-semibold">5</span>
          </div>

           <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

          <div className="flex items-center justify-between text-[11px]">
            <span>Collaboration Score:</span>
            <span className="font-semibold text-purple-600">94%</span>
          </div>
      </PerformanceHeader>
);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ProductivityMetrics);
